export const EDIT_PROFILE_FIELD = 'EDIT_PROFILE_FIELD'
export const FLAG_PROFILE_ERRORS = 'FLAG_PROFILE_ERRORS'
export const UNFLAG_PROFILE_ERRORS = 'UNFLAG_PROFILE_ERRORS'
export const SUBMIT_PROFILE_FAIL = 'SUBMIT_PROFILE_FAIL'
export const SUBMIT_PROFILE_SUCCESS = 'SUBMIT_PROFILE_SUCCESS'